import { Select, SelectButton, SelectButtonCaret, SelectDropdown, Suspense, useFetch } from 'journey-ui'
import React, { useContext, useState } from 'react'
import { PortionOptionBtn } from './PortionOptionBtn'
import { ToppingContext } from '../../contexts/ToppingContext'
import { useToppingPriceUpdater } from '../../hooks/useToppingPriceUpdater'

interface Props {

}

export const PortionInput: React.FC<Props> = () => {
  const { topping: currentTopping } = useContext(ToppingContext)
  const [open, setOpen] = useState(false)

  const [portionToppings = [], setPortionToppings, portionToppingFetcher] = useFetch<PortionOption[]>({
    url: `/api/topping/${currentTopping.hash_id}/portion`,
    isAllowed: open,
  })

  return (
    <Select isOpen={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} className="flex-grow-0">
      <SelectButton className="px-3 py-1 min-h-0 space-x-2">
        <span className="text-xs">{currentTopping.portion_name}</span>
        <SelectButtonCaret className="w-3 h-3" />
      </SelectButton>

      <SelectDropdown>
        <Suspense hook={portionToppingFetcher}>
          {portionToppings.map((portionTopping) => <PortionOptionBtn key={portionTopping.hash_id} currentTopping={currentTopping} portionOption={portionTopping} />)}
        </Suspense>
      </SelectDropdown>
    </Select>
  )
}
